export const map = (
  value: number,
  min1: number,
  max1: number,
  min2: number,
  max2: number,
) => {
  return min2 + (max2 - min2) * ((value - min1) / (max1 - min1))
}
export const mapClamped = (
  value: number,
  min1: number,
  max1: number,
  min2: number,
  max2: number,
) => {
  return clamp(map(value, min1, max1, min2, max2), min2, max2)
}

export const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max)
}
